import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { PreProcessedData } from "./types/pre-processed-data.type";
import { Region } from "./types/region.type";

/* Request / Response Types */
export interface UpdateAllDataAsset {
  key: string;
  regions: Region[];
}

export interface UpdateAllDataResp {
  savedCount: number;
}

/*
 * getPreProcessedData endpoint
 *
 * This returns all the detected AOI's from the pipeline for all assets in a study.
 * It also returns meta data about each asset and an id.
 */
export const getAllPreProcessedData = async (projectId: string, studyId: string) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/data`);
  return resp.data as PreProcessedData[];
};

/**
 * updateAllData function
 *
 * Saves the user-edited region data for all assets in a study to S3.
 * Called at the end of the review step before proceeding to the next step.
 *
 * @param projectId - The project ID
 * @param studyId - The study ID
 * @param assets - Array of assets with their edited regions
 * @returns The count of assets successfully saved
 */
export const updateAllData = async (projectId: string, studyId: string, assets: UpdateAllDataAsset[]) => {
  const resp = await api.put(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/data`, { assets });
  return resp.data as UpdateAllDataResp;
};
